module.exports = __webpack_public_path__ + "static/media/cny-set-2023-3.bcf8e46a.gif";